'use strict';/* global define */define('app/config',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
config.$inject = ["$sceDelegateProvider", "$compileProvider", "AUTH_ENDPOINT", "API_ENDPOINT"];
function config($sceDelegateProvider,$compileProvider,AUTH_ENDPOINT,API_ENDPOINT){$sceDelegateProvider.resourceUrlWhitelist(['self',wildcard(AUTH_ENDPOINT),wildcard(API_ENDPOINT)]);/**
     * if you need debug info, please run
     * angular.reloadWithDebugInfo()
     * in your console
     */// $compileProvider.debugInfoEnabled( false );
}function wildcard(url){return url.replace(/\/*$/,'/**');}module.exports=config;});
